import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo } from "react";
import { datadogInit } from "../../hooks/useLogging/Logging-utils";
import logRocketLauncher from "../../utils/logRocketLauncher";
import { useGetEnvironmentDetails } from "./hooks/useGetEnvironmentDetails";
import { APPLICATION_NAME, DEFAULT_ENVIRONMENT_DETAILS, } from "./utils/environmentProvider-types";
import Loading from "../loading";
const EnvironmentContext = createContext(DEFAULT_ENVIRONMENT_DETAILS);
export const EnvironmentProvider = ({ children }) => {
    const { data, loading } = useGetEnvironmentDetails();
    useEffect(() => {
        if ((data === null || data === void 0 ? void 0 : data.isLogRocketEnabled) === true) {
            logRocketLauncher.init();
        }
        if (data === null || data === void 0 ? void 0 : data.dataDogClientToken) {
            datadogInit(data.dataDogClientToken, data.environment, data.buildVersion, APPLICATION_NAME);
        }
    }, [data]);
    const contextValue = useMemo(() => {
        var _a;
        return Object.assign(Object.assign({}, data), { application: APPLICATION_NAME, loading, error: (_a = data.error) !== null && _a !== void 0 ? _a : null });
    }, [data, loading]);
    // Defer rendering children until environment details are loaded
    if (loading) {
        const isLocalhost = window.location.hostname === "localhost";
        return _jsx(Loading, { text: isLocalhost ? "Environment Provider..." : undefined });
    }
    return _jsx(EnvironmentContext.Provider, Object.assign({ value: contextValue }, { children: children }));
};
export const useEnvironment = () => {
    const context = useContext(EnvironmentContext);
    if (!context) {
        throw new Error("useEnvironment must be used within a EnvironmentProvider");
    }
    return context;
};
